<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import columnChartOptions from "@/config/charts/column";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null
    };
  },
  computed: {
    selectedyAxisType() {
      return this.$store.getters.getSettings.yAxisType;
    }
  },
  watch: {
    selectedDate: function(newDate, oldDate) {
      if (newDate.from !== oldDate.from || newDate.to !== oldDate.to) {
        this.getAPIData(this.selectedDate.from, this.selectedDate.to);
      }
    },
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        this.getAPIData(this.selectedDate.from, this.selectedDate.to);
      }
    }
  },
  created() {
    const onyAxisSelect = type => {
      this.$store.commit("setyAxisType", type);
    };

    this.chartOptions = JSON.parse(JSON.stringify(columnChartOptions));
    this.chartOptions.title.text = this.$lang.charts.hourly_total_active_energy;
    this.chartOptions.yAxis.labels.format = "{value} kWh";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} kWh</b><br/>";
    this.chartOptions.series = [];

    this.chartOptions.yAxis.type = this.selectedyAxisType;
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
    this.chartOptions.exporting.buttons.contextButton.menuItems.push(
      "separator"
    );
    this.chartOptions.exporting.buttons.contextButton.menuItems.push({
      textKey: "scalerChange",
      onclick: function() {
        if (this.userOptions.yAxis.type == "logarithmic") {
          this.userOptions.yAxis.type = "linear";
          this.yAxis[0].update({ type: "linear" });
          onyAxisSelect("linear");
        } else {
          this.userOptions.yAxis.type = "logarithmic";
          this.yAxis[0].update({ type: "logarithmic" });
          onyAxisSelect("logarithmic");
        }
      }
    });
  },

  methods: {
    onPanelSelect(data) {
      this.$nextTick(() => {
        this.getRelayNames(data).then(() => {
          this.getAPIData(data);
        });
      });
    },

    getRelayNames(selected) {
      const { chart } = this.$refs.areaChart;

      while (chart.series.length > 0) {
        chart.series[0].remove(false, false);
      }
      this.chartOptions.series = [];

      return axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          names: true
        },
        withCredentials: true
      })
        .then(response => {
          Object.keys(response.data.data).forEach(relay => {
            this.chartOptions.series.push({
              name: response.data.data[relay].name,
              type: "column",
              marker: {
                enabled: false
              },
              dashStyle: "Solid",
              data: []
            });
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              for (let index = 1; index <= 4; index++) {
                this.chartOptions.series.push({
                  name: this.$lang.charts.relay + " " + index,
                  type: "column",
                  marker: {
                    enabled: false
                  },
                  dashStyle: "Solid",
                  data: []
                });
              }
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/energy",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          from: selected.date.from,
          to: selected.date.to,
          period: "HOUR",
          format: "H"
        },
        withCredentials: true
      })
        .then(response => {
          chart.series[0].setData(response.data.data.R1, false, false, false);
          chart.series[1].setData(response.data.data.R2, false, false, false);
          chart.series[2].setData(response.data.data.R3, false, false, false);
          chart.series[3].setData(response.data.data.R4, false, false, false);

          chart.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code === 610) {
              this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
              chart.series[0].setData([]);
              chart.series[1].setData([]);
              chart.series[2].setData([]);
              chart.series[3].setData([]);
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>